import { render, staticRenderFns } from "./EntityCreationForm.vue?vue&type=template&id=bf9664b2"
import script from "./EntityCreationForm.vue?vue&type=script&lang=js"
export * from "./EntityCreationForm.vue?vue&type=script&lang=js"
import style0 from "./EntityCreationForm.vue?vue&type=style&index=0&id=bf9664b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports